import React from "react";

const CalendarComponent = ({
    monthName,
    year,
    prevMonth,
    nextMonth,
    emptyDays,
    daysInMonth,
    today,
    handleDateClick,
  }) => {
    return (
      <div className="p-4 max-w-md mx-auto bg-white shadow-lg rounded-lg">
        {/* Current Month Header */}
        <div className="text-center mb-4">
          <h2 className="text-2xl font-semibold text-gray-600">
            {monthName} {year}
          </h2>
        </div>
  
        {/* Navigation Buttons */}
        <div className="flex justify-between items-center mb-4">
          <button
            onClick={prevMonth}
            className="text-lg font-semibold text-gray-700 hover:text-gray-900"
          >
            Prev
          </button>
  
          <button
            onClick={nextMonth}
            className="text-lg font-semibold text-gray-700 hover:text-gray-900"
          >
            Next
          </button>
        </div>
  
        {/* Days of the week header */}
        <div className="grid grid-cols-7 gap-2 text-center font-semibold text-gray-600 mb-2">
          {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
            <div key={day}>{day}</div>
          ))}
        </div>
  
        {/* Days in the current month */}
        <div className="grid grid-cols-7 gap-2">
          {emptyDays.map((_, i) => (
            <div key={`empty-${i}`} className="text-gray-400"></div>
          ))}
          {daysInMonth.map((day, index) => {
            const isToday =
              today.getDate() === day.date.getDate() &&
              today.getMonth() === day.date.getMonth();
            return (
              <div
                key={day.date.getDate()}
                className={`text-center p-2 ${
                  isToday ? "font-bold text-red-600" : "text-gray-600"
                } cursor-pointer hover:bg-gray-100 rounded relative flex flex-col justify-between min-h-[45px] min-w-[45px]`}
                onClick={() => handleDateClick(index + 1)}
              >
                <div>{day.date.getDate()}</div>
                <div>{day.birthdays}</div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  
  export default CalendarComponent;